<div class="cancel-dialog-header">
  <h2 mat-dialog-title class="text-xl font-semibold text-[#1b3157]">Cancel my current plan(s)</h2>
  <button
    type="button"
    class="cancel-dialog-close"
    aria-label="Close"
    [hidden]="submitting"
    [disabled]="submitting"
    (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="pt-2">
  <ng-container *ngIf="success; else formTpl">
    <p class="text-gray-800">{{ successMessage }}</p>
  </ng-container>

  <ng-template #formTpl>
    <p class="text-sm text-gray-600 mb-4">
      Enter your name and date of birth. Your request will be reviewed by HR before any plan change.
    </p>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="cancel-form">
      <mat-form-field appearance="outline" class="cancel-field">
        <mat-label>First name</mat-label>
        <input matInput type="text" formControlName="firstName" maxlength="100" autocomplete="given-name" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="cancel-field">
        <mat-label>Last name</mat-label>
        <input matInput type="text" formControlName="lastName" maxlength="100" autocomplete="family-name" />
      </mat-form-field>

      <mat-form-field
        #dobField
        appearance="outline"
        class="cancel-field"
        (mousedown)="matchDobPanelWidth()">
        <mat-label>Date of birth</mat-label>
        <input
          matInput
          formControlName="dateOfBirth"
          [matDatepicker]="dobPicker"
          [min]="minDob"
          [max]="maxDob"
          dateMask
          placeholder="MM/DD/YYYY" />
        <mat-datepicker-toggle matIconSuffix [for]="dobPicker"></mat-datepicker-toggle>
        <mat-datepicker #dobPicker panelClass="cancellation-dob-panel"></mat-datepicker>
      </mat-form-field>

      <p class="text-sm text-gray-500 mb-2">Please complete the security verification below.</p>
      <div id="turnstile-cancellation"></div>

      <p *ngIf="error" class="text-red-600 text-sm mt-2" role="alert">{{ error }}</p>
    </form>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end" class="pt-3">
  <button mat-button type="button" [disabled]="submitting" (click)="close()">
    {{ success ? 'Close' : 'Cancel' }}
  </button>
  <button
    *ngIf="!success"
    mat-flat-button
    color="primary"
    type="submit"
    [disabled]="submitDisabled"
    [attr.aria-busy]="submitting"
    (click)="onSubmit()">
    <mat-spinner *ngIf="submitting" class="submit-spinner" diameter="18"></mat-spinner>
    {{ submitting ? 'Submitting…' : 'Submit request' }}
  </button>
</mat-dialog-actions>